import Modal from 'react-modal';
import React from 'react';
import { YouTubeStack } from './YouTubeStack';

export interface YouTubeTutorialModalProps {
  videoId: string;
  onClose: () => void;
  title: string;
}

export const YouTubeStackModal = ({ videoId, onClose, title }: YouTubeTutorialModalProps) => {
  return (
    <Modal
      isOpen={true}
      overlayClassName="youtube-view__overlay"
      className="attachments-view__content"
      onRequestClose={onClose}
      ariaHideApp={true}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      shouldReturnFocusAfterClose={true}
    >
      <YouTubeStack videoId={videoId} onClose={onClose} title={title} />
    </Modal>
  );
};
